import { isDevOrPreviewSite } from '../../utils/general'
import { F_MINIMALIST_MODE, F_PRESENTATION_MODE } from './constants'

const isDev = isDevOrPreviewSite()

const TINY_PLAN = {
  id: isDev ? 'prod_OaDEo0F1lj38QD' : 'prod_OaDIHVQwiyvU0k',
  label: 'Tiny',
  prices: {
    yearly: {
      stripe: {
        usd: {
          symbol: '$',
          value: 60,
          priceId: isDev ? 'price_1Nn2r6KnX1nnNv6IQK8YG4sv' : 'price_1Nn2rtKnX1nnNv6IgIsA0Wxe'
        },
        eur: {
          symbol: '€',
          value: 60,
          priceId: isDev ? 'price_1PVb5WKnX1nnNv6IWtPB3gru' : 'price_1PlVGeKnX1nnNv6IEpYw5K6m'
        },
        gbp: {
          symbol: '£',
          value: 48,
          priceId: isDev ? 'price_1PVb8yKnX1nnNv6InXSJFugh' : 'price_1PlUzaKnX1nnNv6IiQgnCyor'
        },
        inr: {
          symbol: '₹',
          value: 2520,
          priceId: isDev ? 'price_1PVbCCKnX1nnNv6I4QQHWHSL' : 'price_1Q7FFSKnX1nnNv6IaQwkqWDQ'
        }
      },
      paddle: { priceId: isDev ? 'pri_01kb258nx9tetscgj68asad343' : 'pri_01kery76dy60ea8zmhc57t2en1' },
      payPro: { priceId: isDev ? 102335 : 103218 }
    },
    monthly: {
      stripe: {
        usd: {
          symbol: '$',
          value: 9,
          priceId: isDev ? 'price_1Nn2nnKnX1nnNv6IzoEC0ngV' : 'price_1Nn2rtKnX1nnNv6Isc95ltdV'
        },
        eur: {
          symbol: '€',
          value: 9,
          priceId: isDev ? 'price_1PVb3cKnX1nnNv6I4pogjax4' : 'price_1PlVHIKnX1nnNv6I958myuP7'
        },
        gbp: {
          symbol: '£',
          value: 7,
          priceId: isDev ? 'price_1PVazKKnX1nnNv6IMOXCHbtl' : 'price_1PlUymKnX1nnNv6Io90j5mbk'
        },
        inr: {
          symbol: '₹',
          value: 395,
          priceId: isDev ? 'price_1PVbFlKnX1nnNv6IZrXsjP2h' : 'price_1QiqlrKnX1nnNv6IxtgJHu0O'
        }
      },
      paddle: { priceId: isDev ? 'pri_01kb2567an9vazp9a77va5s1af' : 'pri_01kery61s4p94kwtdeyhaqyhqf' },
      payPro: { priceId: isDev ? 103219 : 103220 }
    }
  },
  fileSizeLimit: 25,
  customDomainsLimit: 0,
  projectLimit: 1,
  visitorLimit: 10000,
  bandwidthLimit: 10,
  features: {
    [F_PRESENTATION_MODE]: true,
    [F_MINIMALIST_MODE]: true
  }
}

export default TINY_PLAN
